/* KH Jeweler inquiry-form.js
   Sends custom design inquiries to the KH Jeweler email endpoint.
   Fallback: if this script fails to load, Shopify's native contact form still works.
*/
(function () {
  'use strict';

  var form = document.getElementById('CustomInquiryForm');
  if (!form) return;

  var section = form.closest('[data-inquiry-section]');
  var endpoint = section ? section.getAttribute('data-inquiry-endpoint') : '';
  var submitButton = form.querySelector('.inquiry-submit');

  function fieldName(selector) {
    return form.querySelector(selector);
  }

  function getValue(name) {
    var field = form.querySelector('[name="' + name + '"]');
    if (!field) return '';
    if (field.type === 'radio') {
      var checked = form.querySelector('[name="' + name + '"]:checked');
      return checked ? checked.value : '';
    }
    return (field.value || '').trim();
  }

  function getValues(name) {
    return Array.from(form.querySelectorAll('[name="' + name + '"]:checked')).map(function (field) {
      return field.value;
    });
  }

  function ensureStatus() {
    var status = form.querySelector('[data-inquiry-status]');
    if (status) return status;

    status = document.createElement('div');
    status.setAttribute('data-inquiry-status', '');
    status.setAttribute('role', 'status');
    status.className = 'hidden border p-6 text-sm';

    var actions = submitButton ? submitButton.closest('.pt-4') : null;
    if (actions) {
      actions.parentNode.insertBefore(status, actions);
    } else {
      form.appendChild(status);
    }

    return status;
  }

  function showStatus(type, message) {
    var status = ensureStatus();
    status.classList.remove('hidden');
    status.textContent = message;

    if (type === 'success') {
      status.className = 'border border-[var(--color-gold)] bg-[var(--color-gold)]/10 p-6 text-sm text-[var(--color-offwhite)]';
    } else {
      status.className = 'border border-[#E07A6B] bg-[#E07A6B]/10 p-6 text-sm text-[#E07A6B]';
    }
  }

  function hideStatus() {
    var status = form.querySelector('[data-inquiry-status]');
    if (status) status.classList.add('hidden');
  }

  function setError(field, msg) {
    if (!field) return;
    var wrapper = field.closest('.form-field');
    var group = field.closest('fieldset') || wrapper;
    var err = wrapper ? wrapper.querySelector('.form-field-error') : null;

    if (!err && group) {
      err = group.querySelector('[data-group-error]');
      if (!err) {
        err = document.createElement('p');
        err.setAttribute('data-group-error', '');
        err.setAttribute('role', 'alert');
        err.className = 'mt-2 text-xs text-[#E07A6B]';
        group.appendChild(err);
      }
    }

    if (err) {
      err.textContent = msg;
      err.classList.remove('hidden');
    }

    field.setAttribute('aria-invalid', 'true');
  }

  function clearError(field) {
    if (!field) return;
    var wrapper = field.closest('.form-field');
    var group = field.closest('fieldset') || wrapper;
    var err = wrapper ? wrapper.querySelector('.form-field-error') : null;

    if (err) {
      err.textContent = '';
      err.classList.add('hidden');
    }

    if (group) {
      group.querySelectorAll('[data-group-error]').forEach(function (groupErr) {
        groupErr.textContent = '';
        groupErr.classList.add('hidden');
      });
    }

    field.removeAttribute('aria-invalid');
  }

  function clearAllErrors() {
    form.querySelectorAll('[aria-invalid="true"]').forEach(function (field) {
      field.removeAttribute('aria-invalid');
    });
    form.querySelectorAll('.form-field-error, [data-group-error]').forEach(function (err) {
      err.textContent = '';
      err.classList.add('hidden');
    });
  }

  function evaluateConditionals() {
    form.querySelectorAll('[data-conditional]').forEach(function (el) {
      var rule;
      try { rule = JSON.parse(el.getAttribute('data-show-when') || '{}'); }
      catch (e) { return; }

      var inputs = form.querySelectorAll('[name="' + rule.name + '"]');
      var show = false;

      inputs.forEach(function (input) {
        if ((input.type === 'checkbox' || input.type === 'radio') && !input.checked) return;

        if (Array.isArray(rule.value)) {
          if (rule.value.indexOf(input.value) !== -1) show = true;
        } else if (input.value === rule.value) {
          show = true;
        }
      });

      el.classList.toggle('hidden', !show);
    });
  }

  function validate() {
    clearAllErrors();
    hideStatus();

    var valid = true;
    var name = fieldName('[name="contact[name]"]');
    var email = fieldName('[name="contact[email]"]');
    var phone = fieldName('[name="contact[phone]"]');
    var preferred = fieldName('[name="contact[preferred_contact]"]');
    var project = fieldName('[name="contact[project_type][]"]');
    var body = fieldName('[name="contact[body]"]');

    if (!name || !name.value.trim()) { setError(name, 'Please enter your name.'); valid = false; }
    if (!email || !email.value.trim()) {
      setError(email, 'Please enter your email.'); valid = false;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim())) {
      setError(email, 'Please enter a valid email address.'); valid = false;
    }
    if (!phone || !phone.value.trim()) { setError(phone, 'Please enter your phone number.'); valid = false; }
    if (!getValue('contact[preferred_contact]')) { setError(preferred, 'Please choose a preferred contact method.'); valid = false; }
    if (!getValues('contact[project_type][]').length) { setError(project, 'Please select at least one project type.'); valid = false; }
    if (!body || body.value.trim().length < 20) { setError(body, 'Please share at least a sentence or two about the piece.'); valid = false; }

    if (!valid) {
      var firstError = form.querySelector('[aria-invalid="true"]');
      if (firstError) firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    return valid;
  }

  function buildPayload() {
    return {
      name: getValue('contact[name]'),
      email: getValue('contact[email]'),
      phone: getValue('contact[phone]'),
      preferredContact: getValue('contact[preferred_contact]'),
      projectType: getValues('contact[project_type][]'),
      projectTypeOther: getValue('contact[project_type_other]'),
      occasion: getValue('contact[occasion]'),
      gemType: getValues('contact[gem_type][]'),
      gemShape: getValue('contact[gem_shape]'),
      carat: getValue('contact[carat]'),
      metal: getValue('contact[metal]'),
      goldColor: getValue('contact[gold_color]'),
      budget: getValue('contact[budget]'),
      timeline: getValue('contact[timeline]'),
      body: getValue('contact[body]'),
      consentMarketing: getValue('contact[consent_marketing]'),
      company: getValue('contact[company]'),
      pageUrl: window.location.href,
      userAgent: window.navigator.userAgent
    };
  }

  function setSubmitting(isSubmitting) {
    if (!submitButton) return;
    submitButton.disabled = isSubmitting;
    submitButton.style.opacity = isSubmitting ? '0.65' : '';
    submitButton.style.cursor = isSubmitting ? 'not-allowed' : '';
    if (!submitButton.getAttribute('data-original-text')) {
      submitButton.setAttribute('data-original-text', submitButton.textContent.trim());
    }
    if (isSubmitting) {
      submitButton.childNodes[0].textContent = 'Sending... ';
    } else {
      submitButton.childNodes[0].textContent = submitButton.getAttribute('data-original-text') + ' ';
    }
  }

  form.addEventListener('change', function (event) {
    evaluateConditionals();
    clearError(event.target);
  });

  form.addEventListener('input', function (event) {
    clearError(event.target);
  });

  form.addEventListener('submit', function (event) {
    if (!endpoint) return;
    event.preventDefault();

    if (!validate()) return;

    setSubmitting(true);

    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(buildPayload())
    })
      .then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (data) {
          if (!response.ok || !data.success) {
            throw new Error(data.error || 'The inquiry could not be sent. Please try again.');
          }
          return data;
        });
      })
      .then(function () {
        form.reset();
        evaluateConditionals();
        clearAllErrors();
        showStatus('success', 'Thank you. Your inquiry was sent and a confirmation email is on its way to you. Kevin will personally reach out soon.');
      })
      .catch(function (error) {
        showStatus('error', error.message || 'The inquiry could not be sent. Please email kevin@khjeweler.com directly.');
      })
      .finally(function () {
        setSubmitting(false);
      });
  });

  evaluateConditionals();
})();
